// components/TrackingProvider.tsx
// 추적 SDK 초기화 + 고객 ID sync

'use client';

import { useEffect } from 'react';
import { setCustomerId, flush } from '@/lib/tracking';
import { useAuth } from '@/context/AuthContext';

interface TrackingProviderProps {
  children: React.ReactNode;
}

// 다양한 형태(숫자, 숫자 string, GID)로 들어올 수 있는 customerId를 admin DB와
// 매칭되는 GID 포맷으로 정규화. 기존 30일 numeric cookie 사용자도 cover.
function normalizeCustomerId(raw: unknown): string | null {
  if (raw == null) return null;
  const s = String(raw);
  if (s === '' || s === 'null' || s === 'undefined') return null;
  return s.startsWith('gid://') ? s : `gid://shopify/Customer/${s}`;
}

export function TrackingProvider({ children }: TrackingProviderProps): React.ReactElement {
  // AuthContext에서 로그인된 고객 ID를 가져옴 (null = 비로그인)
  const { user } = useAuth();
  const customerId = normalizeCustomerId(user?.customerId);

  // 고객 ID 변경 시 SDK에 sync
  useEffect(() => {
    setCustomerId(customerId);
  }, [customerId]);

  // 앱 종료 시 큐에 남은 이벤트 강제 flush
  useEffect(() => {
    return () => {
      flush();
    };
  }, []);

  return <>{children}</>;
}
